var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._m(0),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Número de animais por tipo:",
                  content: _vm.formataCriacoes(_vm.pratica.criacoes),
                  isContentInNextLine: true
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Tipo de tratamento:",
                  content: _vm.formataTipoTratamento(
                    _vm.pratica.tiposTratamento
                  )
                }
              }),
              _vm._v(" "),
              _vm.pratica.tiposTratamento.length &&
              _vm.pratica.tiposTratamento.includes("OUTROS")
                ? _c("app-display", {
                    attrs: {
                      label: "Outro tipo de tratamento:",
                      content: _vm.pratica.outrosTiposTratamento
                    }
                  })
                : _vm._e()
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-col",
            { attrs: { span: 12 } },
            [
              _c("app-display", {
                attrs: {
                  label: "Tipo de manejo predominante:",
                  content: _vm.formataTipoManejo(_vm.pratica.tiposManejo)
                }
              }),
              _vm._v(" "),
              _c("app-display", {
                attrs: {
                  label: "Aproveitamento do resíduo tratado:",
                  content: _vm.formataAproveitamento(
                    _vm.pratica.tiposAproveitamentoResiduos
                  )
                }
              }),
              _vm._v(" "),
              _vm.pratica.tiposAproveitamentoResiduos.length &&
              _vm.pratica.tiposAproveitamentoResiduos.includes("OUTROS")
                ? _c("app-display", {
                    attrs: {
                      label: "Outro aproveitamento do resíduo tratado:",
                      content: _vm.pratica.outrosTiposAproveitamentoResiduos
                    }
                  })
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("Financiamento", {
        attrs: {
          financiamento: {
            financiamentos: _vm.pratica.financiamentos,
            outroFinanciamento: _vm.pratica.outroFinanciamento
          }
        }
      }),
      _vm._v(" "),
      _c("Descricao", { attrs: { descricao: _vm.pratica.descricao } })
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", [
      _c("span", { staticClass: "title-praticas" }, [
        _vm._v("Dados da prática")
      ]),
      _vm._v(" "),
      _c("hr")
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-05f078dd", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05f078dd","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components(new)/UI/Modals/VisualizacaoCadastro/Cadastro/Praticas/MRPA/MRPA.vue
// module id = null
// module chunks = 